import {
  regStatusNew as regStatusData,
  orgType as orgTypeData,
  highFilter as highFilterData,
} from '@component/search/config/filter';
import { IQueryParams } from 'components/search/type';
import moment from 'moment';

interface IParamsProps {
  selectedOptions: IQueryParams;
  queryKey: string;
  pageNum: number;
  pageSize: number;
  sortType: string;
}

const now = Date.now();

// 获取指定年的时间戳
const getTimestamp = (num: number) => {
  const yearMS = 31536000000;

  return num ? now - yearMS * num : now;
};

export const generateParams = (query: IParamsProps) => {
  const { selectedOptions, queryKey, pageNum, pageSize, sortType } = query;
  //  对企业状态的值做特殊处理
  const handleRegStatusParams = () => {
    const res: IQueryParams = {};
    const { regStatusNew } = selectedOptions;
    if (regStatusNew) {
      const regStatusVal = selectedOptions.regStatusNew;
      regStatusData.forEach((item: IQueryParams) => {
        if (item.val == regStatusVal) {
          res.regStatusNew = item.title;
          return false;
        }
      });
    }
    return res;
  };

  //  对企业类型的值做特殊处理
  const handleOrgTypeParams = () => {
    const res: IQueryParams = {};
    const { orgType } = selectedOptions;
    if (orgType) {
      const orgTypeVal = selectedOptions.orgType;
      orgTypeData.forEach((item: IQueryParams) => {
        if (item.val == orgTypeVal) {
          res.orgType = item.title;
          return false;
        }
      });
    }
    return res;
  };

  // 对注册资本格式做特殊处理
  const handleEstiblishTime = () => {
    const result: IQueryParams = {};
    // 匹配非自定义选项
    const estiblishTimeReg = /\d{4}-\d{2}-\d{2}/;
    const { estiblishTimeStart = '', estiblishTimeEnd = '' } = selectedOptions;
    if (estiblishTimeEnd) {
      result.estiblishTimeEnd = estiblishTimeReg.test(estiblishTimeEnd)
        ? moment(`${estiblishTimeEnd} 23:59:59`).valueOf()
        : getTimestamp(estiblishTimeStart);
    }

    if (estiblishTimeStart || estiblishTimeStart === 0) {
      result.estiblishTimeStart = estiblishTimeReg.test(estiblishTimeStart)
        ? moment(`${estiblishTimeStart} 0:0:0`).valueOf()
        : getTimestamp(estiblishTimeEnd);
    }

    return result;
  };

  // 对省市区数据做特殊处理
  const handleArea = () => {
    const options = Object.assign({}, selectedOptions);
    // debugger;
    if (options.customAreaCode) {
      options.city && delete options.city;
      options.base && delete options.base;
      // return options;
    }

    if (options.city) {
      options.customAreaCode = options.cacheCode;
      options.city && delete options.city;
      options.base && delete options.base;
      // return options;
    }

    if (options.base) {
      options.customAreaCode = options.cacheCode;
      options.base && delete options.base;
      // return options;
    }

    // 行业分类入参数处理
    if (options.categoryGuobiao2017) {
      options.categoryGuobiao2017 =
        options.terInduCode || options.secInduCode || options.categoryGuobiao2017;
      options.terInduCode && delete options.terInduCode;
      options.secInduCode && delete options.secInduCode;
    }

    /**
     * 接口入参数，字段名称映射处理
     */
    // 上市状态
    if (options.hasBondType) {
      highFilterData.hasBondType.forEach((item) => {
        if (item.val == options.hasBondType) {
          options.listedType = item.title;
          delete options.hasBondType;
          return false;
        }
      });
    }
    // 融资信息
    if (options.hasFinancing) {
      highFilterData.hasFinancing.forEach((item) => {
        if (item.val == options.hasFinancing) {
          options.financingRound = item.title;
          delete options.hasFinancing;
          return false;
        }
      });
    }
    // 网址信息
    if (options.website) {
      options.hasWebsite = options.website;
      delete options.website;
    }
    // 税务评级
    if (options.isTaxLevel) {
      options.taxLevel = options.isTaxLevel;
      delete options.isTaxLevel;
    }
    // 一般纳税人
    if (options.isTaxpayer) {
      options.isGeneralTaxpayer = options.isTaxpayer;
      delete options.isTaxpayer;
    }

    // 修改词
    if (options.modifiedQuery) {
      options.allowModifyQuery = '2';
      delete options.modifiedQuery;
    }
    return options;
  };
  const newOptions = handleArea();
  // 关键词为空时，默认数据的入参
  const nullQueryKey = () => {
    if (queryKey === '') {
      return {
        word: '$',
        type: 'tail',
      };
    }
    return {};
  };

  return {
    word: queryKey || '$',
    sortType,
    pageSize,
    referer: 'search',
    ...nullQueryKey(),
    ...newOptions,
    pageNum: Number(pageNum),
    ...handleRegStatusParams(),
    ...handleOrgTypeParams(),
    ...handleEstiblishTime(),
  };
};
